import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton
} from 'react-share';

import {
  DropdownMenu,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  ButtonGroup,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';

import copyToClipboard from 'utils/copyToClipboard';
import ToolTip from '../components/Tooltip';

library.add(fab);

const generateBodyText = (name, reward, url) => {
  let surveytext = `Take our survey "${name}".`;
  let rewardText = reward[0]
    ? `You'll receive the reward "${reward}" when you take this survey.`
    : '';
  return `${surveytext} ${rewardText} ${url ? url : ''}`;
};

class ShareButton extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      copySucceed: false
    };
    this.bodyText = this.bodyText.bind(this);
  }

  bodyText(url) {
    return generateBodyText(this.props.name, this.props.reward, url);
  }

  displayAndHideCopyText() {
    var that = this;
    this.setState({ copySucceed: true });
    setTimeout(() => {
      that.setState({ copySucceed: false });
    }, 5000);
  }

  handleCopyText() {
    const { url } = this.props;
    copyToClipboard(url);
    this.displayAndHideCopyText();
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  render() {
    const { title, icon } = this.props;
    const { dropdownOpen } = this.state;
    const btnText = title || "Share";

    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle
          id={`share_link${this.props.id}`}
          className="btn-outline-secondary btn-sm mr-1 mb-1"
        >
          {icon && <FontAwesomeIcon icon="share-alt" />}
          {btnText}
        </DropdownToggle>
        <ToolTip
          title={"Share link"}
          placement="bottom"
          hidden={dropdownOpen}
          target={`share_link${this.props.id}`}
        />
        <DropdownMenu
          className="pl-2 pr-2 custom-survey-share-container"
          style={{ width: 180 }}
        >
          <DropdownItem header className="pl-0 pt-0 pb-0">
            Social Media
          </DropdownItem>
          <div>
            <ButtonGroup>
              <FacebookShareButton url={this.props.url} quote={this.bodyText()}>
                <FontAwesomeIcon
                  icon={['fab', 'facebook']}
                  className="facebook-share-button"
                />
              </FacebookShareButton>
              <TwitterShareButton url={this.props.url} title={this.bodyText()}>
                <FontAwesomeIcon
                  icon={['fab', 'twitter']}
                  style={{ color: '#1DA1F2', cursor: 'pointer', fontSize: 20 }}
                />
              </TwitterShareButton>
            </ButtonGroup>
          </div>
          <hr />
          <div>
            <EmailShareButton
              body={this.bodyText(this.props.url)}
              subject="Soono Survey"
              className="custom-survey-share-button"
            >
              <span className="custom-survey-share-text custom-survey-share-text-email">
                Email this survey
              </span>
            </EmailShareButton>
          </div>
          <hr />
          <div>
            <span className="custom-survey-share-text">
              Link to this survey
            </span>
            <InputGroup
              size="sm"
              className="pl-1 mr-1"
              style={{ backgroundColor: '#f5f5f5' }}
            >
              <InputGroupAddon
                addonType="prepend"
                className="mt-1 ml-1 mb-0 pr-0"
                style={{ cursor: 'pointer', marginRight: -5 }}
                onClick={this.handleCopyText.bind(this)}
                data-toggle="tooltip"
                title="Copy to clipboard"
              >
                <FontAwesomeIcon icon="cut" style={{ fontSize: 16 }} />
              </InputGroupAddon>
              <Input
                className="ml-0 pl-0 border-0 link-text-box"
                defaultValue={this.props.url}
                readOnly
              />
            </InputGroup>
            <span style={{ fontSize: 10 }}>
              {this.state.copySucceed ? 'Copied!' : ''}
            </span>
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

ShareButton.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  reward: PropTypes.array.isRequired,
  id: PropTypes.number.isRequired,
};

export default ShareButton;



// WEBPACK FOOTER //
// ./src/utils/ShareButton.js